import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { NgxImageZoomComponent } from 'ngx-image-zoom';
import moment from 'moment';
import { MatDialog } from '@angular/material/dialog';
import { AppConfig } from '../../app/app.config';
import { ConnectionService } from '../../services/connection-service';
import { EditInstantCheckup } from '../../app/chat/view/instant-checkup/edit-instant-checkup';
import { Broadcaster } from '../broadcaster';

@Component({
    selector: 'instant-checkup-magnifier',
    templateUrl: 'instant-checkup-magnifier.html',
    styleUrls: ['./instant-checkup-magnifier.scss'],
    standalone: false
})
export class InstantCheckUpMagnifierComponent {
  user: any;
  @Input('user')
  set setUser(user: any) {
    if (!user) return;
    this.user = user;
  }
  @ViewChild('imageLense', { static: false }) ngxImageZoomComponent: NgxImageZoomComponent;
  @ViewChild('scrollContainer', { static: false }) scrollContainer: ElementRef;
  @Output('needHelpButtonClicked') needHelpButtonClicked: EventEmitter<boolean> = new EventEmitter();
  selectedInstantCheckUpImageUrl: string;
  selectedInstantCheckUpImageIndex: number;
  instantCheckUpImageList: Array<any> = [];
  selectedInstantCheckUpImageCreatedAt: string;
  userExtraInfo: Table.UserExtraInformation['attributes'];
  constructor(
    public appConfig: AppConfig,
    private dialog: MatDialog,
    private broadcasterService: Broadcaster,
    private connectionService: ConnectionService) {}

  async ngOnInit(): Promise<void> {
    await this.loadUserExtraInformation();
    await this.loadInstantCheckUps();
  }

  async loadUserExtraInformation(): Promise<void> {
    try {
      const result = await this.connectionService.findUserExtraInformation(this.user);
      this.userExtraInfo = result.data.data as unknown as Table.UserExtraInformation['attributes'];
    } catch (error) {
      this.broadcasterService.broadcast('NOTIFY',
        { message: 'userExtraInformation not found', type: this.appConfig.Shared.Toast.Type.WARNING });
    }
  }

  async loadInstantCheckUps(): Promise<void> {
    const instantCheckUpImages = await this.connectionService.fetchUserInstantCheckup({
      userId: this.user.get('username'),
      skip: this.instantCheckUpImageList?.length,
      limit: 15,
      project: ['imagePath', 'type', 'compressedImagePath', 'isMainUser', 'aiResponse'],
    });
    instantCheckUpImages.forEach((each_: any) => {
      const each = each_;
      each.differenceInDays = moment().diff(each.createdAt, 'days');
    });
    this.instantCheckUpImageList = [...this.instantCheckUpImageList, ...instantCheckUpImages];
    if (!this.selectedInstantCheckUpImageUrl) {
      this.selectedInstantCheckUpImageUrl = this.instantCheckUpImageList[0].imagePath;
      this.selectedInstantCheckUpImageCreatedAt = `${moment(this.instantCheckUpImageList[0].createdAt)
        .format('DD MMM, YY')} (${this.instantCheckUpImageList[0].differenceInDays} days)`;
      this.selectedInstantCheckUpImageIndex = 0;
    }
  }

  async editPhotoType(index: number, id: string): Promise<void> {
    const imageUrl = this.instantCheckUpImageList[index].imagePath;
    const dialogRef = this.dialog.open(EditInstantCheckup, { data: { id, imageUrl } });
    dialogRef.afterClosed().subscribe((data: any): any => {
      this.instantCheckUpImageList[index].type = data.get('type');
    });
  }
  async openImage(index: number): Promise<void> {
    this.selectedInstantCheckUpImageIndex = index;
    this.selectedInstantCheckUpImageUrl = this.instantCheckUpImageList[this.selectedInstantCheckUpImageIndex].imagePath;
    this.selectedInstantCheckUpImageCreatedAt = `${moment(this.instantCheckUpImageList[this.selectedInstantCheckUpImageIndex].createdAt)
      .format('DD MMM YY')}, (${this.instantCheckUpImageList[this.selectedInstantCheckUpImageIndex].differenceInDays} days)`;
  }

  async deletePhoto(): Promise<void> {
    const instantCheckUpToDelete = this.instantCheckUpImageList[this.selectedInstantCheckUpImageIndex];
    this.instantCheckUpImageList.splice(this.selectedInstantCheckUpImageIndex, 1);
    await this.connectionService.deleteInstantCheckUp(instantCheckUpToDelete.objectId, this.user.get('username'));
    this.moveToOtherPhoto(-1);
  }

  moveToOtherPhoto(moveOrder: number): void {
    this.selectedInstantCheckUpImageIndex += moveOrder;
    if (this.selectedInstantCheckUpImageIndex < 0) {
      this.selectedInstantCheckUpImageIndex = 0;
    }
    this.selectedInstantCheckUpImageUrl = this.instantCheckUpImageList[this.selectedInstantCheckUpImageIndex].imagePath;
    this.selectedInstantCheckUpImageCreatedAt = `${moment(this.instantCheckUpImageList[0].createdAt)
      .format('DD MMM YY')}, (${this.instantCheckUpImageList[this.selectedInstantCheckUpImageIndex].differenceInDays} days)`;
    this.openImage(this.selectedInstantCheckUpImageIndex);
  }

  async onScroll(event: Event): Promise<void> {
    const target = event.target as HTMLElement;
    const { scrollHeight, scrollTop, clientHeight }: { scrollHeight: number; scrollTop: number; clientHeight: number } = target;
    if (scrollTop + clientHeight >= scrollHeight) {
      await this.loadInstantCheckUps();
    }
  }

  openWaitingForImagePopup(): void {
    this.needHelpButtonClicked.emit();
  }

  getClass(instantCheckUp: Table.InstantCheckup['attributes']): string {
    if (this.userExtraInfo?.faceIds?.length) {
      const mainUserFaceIds = this.userExtraInfo.faceIds.map((faceId) => faceId.toString());
      if (mainUserFaceIds.includes(instantCheckUp.aiResponse?.faceid?.toString())) {
        return 'fas fa-star-of-life consultationIconRed';
      }
    }
    if (instantCheckUp.isMainUser) {
      return 'fas fa-star-of-life consultationIconGreen';
    }
    return '';
  }
}
